import { Component, h } from 'preact';
import { Actions, actions, BookingState, connectStore } from '../../../store';
import { AmDurationItem, Properties } from '../../../common';
import { Modal, ModalBody, ModalHeader, ModalTitle } from '../../../modal';
import DurationRadio from '../DurationRadio/DurationRadio';
import { FinText } from '../../../i18n';

export interface DurationModalProps extends Properties {}

interface StoreProps {
  items: AmDurationItem[];
  duration: string;
}

const mapStateToProps = ({
  amState: {
    amSelection: { duration, locations },
  },
}: BookingState): StoreProps => ({
  items: locations.holidayType.items || [],
  duration,
});

type EffectiveProps = DurationModalProps & StoreProps & Actions;

@connectStore({ mapStateToProps, actions })
export default class DurationModal extends Component<DurationModalProps> {
  setDuration = (item: AmDurationItem): void => {
    const { setAmDuration } = this.props as EffectiveProps;
    setAmDuration(item.code);
  };

  render({ items, duration }: EffectiveProps): h.JSX.Element {
    return (
      <Modal class="bw-duration-modal">
        <ModalHeader>
          <ModalTitle>
            <FinText id="aurinkomatkat.selectDuration" />
          </ModalTitle>
        </ModalHeader>
        <ModalBody class="ps-large-x">
          {items.map((item: AmDurationItem, i: number) => (
            <DurationRadio
              key={item.code}
              class={`${i !== items.length - 1 ? 'border-bottom' : ''}`}
              item={item}
              checked={item.code === duration}
              onSelection={this.setDuration}
            />
          ))}
        </ModalBody>
      </Modal>
    );
  }
}
